import { render, staticRenderFns } from "./PlusImportAdd.vue?vue&type=template&id=8d542b5a&scoped=true"
import script from "./PlusImportAdd.vue?vue&type=script&lang=js"
export * from "./PlusImportAdd.vue?vue&type=script&lang=js"
import style0 from "./PlusImportAdd.vue?vue&type=style&index=0&id=8d542b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d542b5a",
  null
  
)

export default component.exports